/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: I18nFixture
// source: i18n/*/*.json

import type { LibraryType } from "@pdfking/i18n"
import type { EnumUnion } from "@pdfking/structs"
import { LibraryFromJson } from "@pdfking/i18n"

const raw: LibraryType<Readonly<{
  content: EnumUnion<{
    CONTENT_AGENDA_ALTAIR: undefined
    CONTENT_AGENDA_DAILY: undefined
    CONTENT_AGENDA_KIONA: undefined
    CONTENT_AGENDA_KIONA_DAILY: undefined
    CONTENT_AGENDA_LEIXO: undefined
    CONTENT_AGENDA_MUNA: undefined
    CONTENT_AGENDA_PAPYRUS: undefined
    CONTENT_AGENDA_PERPETUAL: undefined
    CONTENT_AGENDA_PERPETUAL_DAILY: undefined
    CONTENT_AGENDA_WEEKLY: undefined
    CONTENT_BOOK: undefined
    CONTENT_BOX: undefined
    CONTENT_CALENDAR_AKINDEZ: undefined
    CONTENT_CALENDAR_AKURA: undefined
    CONTENT_CALENDAR_BELWE: undefined
    CONTENT_CALENDAR_CLAN: undefined
    CONTENT_CALENDAR_DASH: undefined
    CONTENT_CALENDAR_DUBIEL: undefined
    CONTENT_CALENDAR_EAVES: undefined
    CONTENT_CALENDAR_HAMURZ: undefined
    CONTENT_CALENDAR_HOOGE: undefined
    CONTENT_CALENDAR_INTERSTATE: undefined
    CONTENT_CALENDAR_KAUSHAN: undefined
    CONTENT_CALENDAR_KEBBY: undefined
    CONTENT_CALENDAR_LATO: undefined
    CONTENT_CALENDAR_MADISON: undefined
    CONTENT_CALENDAR_MILO: undefined
    CONTENT_CALENDAR_MONTH: undefined
    CONTENT_CALENDAR_NELSON: undefined
    CONTENT_CALENDAR_RALEWAY: undefined
    CONTENT_CALENDAR_ROBOTO: undefined
    CONTENT_CALENDAR_RODDENBERRY: undefined
    CONTENT_CALENDAR_SPREAD: undefined
    CONTENT_CALENDAR_STYMIE: undefined
    CONTENT_CALENDAR_TRIXIE: undefined
    CONTENT_CALENDAR_VINNIE: undefined
    CONTENT_CALENDAR_WONDERWALL: undefined
    CONTENT_CALENDAR_YEAR: undefined
    CONTENT_COUNTERFOIL: undefined
    CONTENT_DEPLIANT: undefined
    CONTENT_NOTEPAD_BLANK: undefined
    CONTENT_NOTEPAD_DOTTED: undefined
    CONTENT_NOTEPAD_LINED: undefined
    CONTENT_NOTEPAD_LINED_8: undefined
    CONTENT_NOTEPAD_MILLIMETER: undefined
    CONTENT_NOTEPAD_SQUARED: undefined
    CONTENT_NOTEPAD_SQUARED_10: undefined
    CONTENT_PLANNER_ALBERTUS: undefined
    CONTENT_PLANNER_LEXICON: undefined
    CONTENT_PLANNER_LUBALIN: undefined
    CONTENT_PLANNER_PERPETUAL: undefined
    CONTENT_PLANNER_WEEKLY: undefined
  }>
}>, "en" | "fr" | "it"> = {
  content: {
    en: () => import("../i18n/content/en.json"),
    fr: () => import("../i18n/content/fr.json"),
    it: () => import("../i18n/content/it.json"),
  },
} as const

export const { content } = LibraryFromJson(raw)
